'use client';

// Removed zod and react-hook-form imports
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { useToast } from '@/hooks/use-toast';

// Formspree imports
import { useForm, ValidationError } from '@formspree/react';

export function ContactForm() {
  const { toast } = useToast();
  
  // Formspree hook
  const [state, handleSubmit] = useForm("mldbqokb"); // Using the provided Formspree ID

  if (state.succeeded) {
      return (
        <div className="text-left py-10">
          <p className="text-lg font-semibold text-gray-800">Thanks for your message!</p>
          <p className="text-gray-600">We will get back to you soon.</p>
        </div>
      );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
          Name
        </label>
        <Input
          id="name"
          type="text" // Changed to text as name is not an email
          name="name"
          placeholder="Your Name"
          // Removed conditional class for border-red-500
        />
        <ValidationError 
          prefix="Name" 
          field="name"
          errors={state.errors}
          className="text-sm text-red-500"
        />
      </div>
      
      <div className="space-y-2">
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
          Email
        </label>
        <Input
          id="email"
          type="email"
          name="email"
          placeholder="Your Email"
          // Removed conditional class for border-red-500
        />
        <ValidationError 
          prefix="Email" 
          field="email"
          errors={state.errors}
          className="text-sm text-red-500"
        />
      </div>
      
      <div className="space-y-2">
        <label htmlFor="summary" className="block text-sm font-medium text-gray-700">
          Brief Idea Summary
        </label>
        <Textarea
          id="summary"
          name="summary" // Changed name to summary
          placeholder="Describe your idea in a few sentences"
          rows={5}
          // Removed conditional class for border-red-500
        />
        <ValidationError 
          prefix="Summary" 
          field="summary"
          errors={state.errors}
          className="text-sm text-red-500"
        />
      </div>
      
      <Button 
        type="submit" 
        className="w-full md:w-auto bg-[#0F62FE] text-white hover:bg-blue-700"
        disabled={state.submitting}
      >
        {state.submitting ? 'Submitting...' : 'Submit'}
      </Button>
    </form>
  );
}
